import Button from "devextreme-react/button";
import { alert } from "devextreme/ui/dialog";
import { useContext } from "react";
import { LoadPagePanel } from "../../../../components";
import { AR, OrderStatus } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitInvoice } from "../api/submit-invoice";
import { POInvoiceContext } from "../context/POInvoiceContext";
import { PurchaseOrderContext } from "../context/PurchaseOrderContext";

export default function SubmitInvoiceButton() {

	const { invoice } = useContext(POInvoiceContext);
	const { order, refetchOrder } = useContext(PurchaseOrderContext);

	const submitInvoice = useSubmitInvoice({
		invoice: {
			purchaseOrderID: order.details.purchaseOrderID,
			invoiceNumber: invoice.details.invoiceNumber!,
			tax: invoice.details.tax,
			discount: invoice.details.discount,
			cutCharge: invoice.details.cutCharge,
			freightAmount: invoice.details.freightAmount,
			invoiceTotal: invoice.details.invoiceTotal
		},
		products: invoice.details.products.filter(x => x.selected).map((x, index) => {
			return {
				poProductID: x.poProductID!,
				lineNumber: index + 1,
				quantity: x.quantity ?? 0,
				uom: x.uom,
				sku: x.sku,
				itemDescription: x.itemDescription,
				unitPrice: x.unitPrice
			}
		}),
		onSuccess: (result) => {

			if (result.activeARs.includes(AR.POSageToVerifyOverage)) {
				alert("Invoice amount is greater than Purchase Order amount.<br/>Invoice will be put on hold until further review.", "Invoice Overage");
			}
			else {
				showSuccessMessage('Invoice has been submitted');
			}

			refetchOrder();
		},
		onError: (error) => showErrorMessage(error)
	});

	function validate() {
		if (!invoice.details.products.some(x => x.selected)) {
			showErrorMessage("At least one product must be selected");
			return false;
		}

		if (invoice.details.invoiceTotal === 0) {
			showErrorMessage("$0 invoice cannot be submitted");
			return false;
		}

		return true;
	}

	return (
		<>
			<Button
				text="Submit Invoice"
				icon="Inscyth-Confirm"
				visible={order.details.activeARs.includes(AR.PODistributorToInvoice) ||
					order.details.activeARs.includes(AR.POServiceProviderToInvoice)}
				disabled={order.details.orderStatusID === OrderStatus.Pending || submitInvoice.isLoading}
				onClick={(e) => {
					let result = e.validationGroup.validate();
					if (result.isValid) {
						if (validate()) {
							submitInvoice.mutate();
						}
					}
				}} >
			</Button>
			<LoadPagePanel visible={submitInvoice.isLoading}></LoadPagePanel>
		</>
	)
}
